















import Vue from 'vue'
export default Vue.extend({
  name: 'UserManagement',
  data() {
    return {
      model: {},
    }
  },
  methods: {},
})
